/**
* Protocol version
*/
export const PROTO_VERSION = "1.16.0.20260202.093826";
